// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gs-searchbar {
    width: 100%;
    height: 100%;
    left: -10px;
}
.search-input {
    padding: 0.5rem;
    width: 250px;
    border-radius: 5px;
    /* border: 1px solid #ccc; */
    color: black;
}
  
.search-popup {
    position: absolute;
    top: 2.5rem;
    /* left: 1rem; */
    /* background: black; */
    /* border: 1px solid #ccc; */
    border-radius: 5px;
    width: 300px;
    z-index: 10;
    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}
  
.search-result {
    padding: 0.5rem;
    gap: 5px;
    cursor: pointer;
}
  
/* .search-result:hover {
    background-color: #f0f0f0;
} */

.src-option-btn {
    width: 10px;
    height: 10px;
    margin-left: 20px;
    background: none;
    /* color: black; */
}
`, "",{"version":3,"sources":["webpack://./src/components/common/GlobalSearch/GlobalSearch.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".gs-searchbar {\n    width: 100%;\n    height: 100%;\n    left: -10px;\n}\n.search-input {\n    padding: 0.5rem;\n    width: 250px;\n    border-radius: 5px;\n    /* border: 1px solid #ccc; */\n    color: black;\n}\n  \n.search-popup {\n    position: absolute;\n    top: 2.5rem;\n    /* left: 1rem; */\n    /* background: black; */\n    /* border: 1px solid #ccc; */\n    border-radius: 5px;\n    width: 300px;\n    z-index: 10;\n    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n  \n.search-result {\n    padding: 0.5rem;\n    gap: 5px;\n    cursor: pointer;\n}\n  \n/* .search-result:hover {\n    background-color: #f0f0f0;\n} */\n\n.src-option-btn {\n    width: 10px;\n    height: 10px;\n    margin-left: 20px;\n    background: none;\n    /* color: black; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
